import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Portfolio from './components/Portfolio';
import Testimonials from './components/Testimonials';
import CTA from './components/CTA';
import Contact from './components/Contact';
import Footer from './components/Footer';
import QuoteModal from './components/QuoteModal';
import { useSchemaOrg, generateLocalBusinessSchema, generateWebSiteSchema, generateServiceSchema, generateBreadcrumbSchema } from '../../utils/seo';

export default function HomePage() {
  const [isQuoteModalOpen, setIsQuoteModalOpen] = useState(false);

  const handleGetQuote = () => {
    setIsQuoteModalOpen(true);
  };

  const handleViewPortfolio = () => {
    document.getElementById('portfolio')?.scrollIntoView({ behavior: 'smooth' });
  };

  // Update page title and meta on mount
  useEffect(() => {
    document.title = 'Best Call Restoration - Professional Home Remodeling Services in Winter Garden, FL';
  }, []);

  // Add Schema.org structured data
  useSchemaOrg([
    generateLocalBusinessSchema(),
    generateWebSiteSchema(),
    ...generateServiceSchema(),
    generateBreadcrumbSchema([
      { name: 'Home', url: '/' }
    ])
  ]);

  return (
    <div className="min-h-screen bg-white">
      <Hero onGetQuote={handleGetQuote} onViewPortfolio={handleViewPortfolio} />
      <About />
      <Services />
      <Portfolio />
      <Testimonials />
      <CTA onGetQuote={handleGetQuote} />
      <Contact />
      <Footer />
      <QuoteModal isOpen={isQuoteModalOpen} onClose={() => setIsQuoteModalOpen(false)} />
    </div>
  );
}
